export const HOME = '/'
export const PROFILE = '/:ensName'